<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 5657 5657"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <path class="fil0"
          d="M5657 5082c0,318 -257,575 -575,575l-4507 0c-317,0 -575,-257 -575,-575l0 -4507c0,-317 258,-575 575,-575l4507 0c318,0 575,258 575,575l0 4507z"/>
   </g>
    <g id="Vrstva_x0020_1_0">
    <path class="fil1 str0"
          d="M3232 3920c153,-60 307,-67 477,-55 -44,68 -160,165 -225,232 -88,90 -97,236 82,233 64,-28 349,-332 414,-398 214,-213 194,-186 -63,-445 -160,-161 -335,-403 -457,-303 -156,128 203,338 248,438 -509,21 -1303,3 -1861,1 -86,0 -217,-16 -276,35 -75,66 -33,140 24,191 108,33 1072,17 1259,12 -59,99 -350,293 -376,740 -7,128 -14,437 -1,557 16,152 235,202 236,-72 1,-456 -15,-957 519,-1166z"/>
      <g id="_879659328">
     <path class="fil1"
           d="M2538 2567c-13,-41 -12,-168 -1,-218l594 -4 3 223c-51,17 -412,6 -519,7 -32,0 -51,5 -77,-8zm45 -662c-33,-155 73,-281 200,-306 160,-32 278,79 303,200 68,332 -434,433 -503,106zm-833 64c55,557 565,1033 1199,966 570,-60 1026,-559 970,-1201 -48,-557 -570,-1037 -1203,-969 -348,38 -629,243 -771,452 -97,140 -127,221 -172,378 -30,106 -34,264 -23,374z"/>
        <path class="fil1"
              d="M4032 1408c44,110 77,311 76,442 0,191 -37,279 -76,442 248,-2 232,-25 301,62l97 123 354 1 -1 -1257 -355 2c-186,231 -68,183 -396,185z"/>
        <path class="fil1"
              d="M1243 2470c182,-231 86,-172 393,-179 -115,-420 -96,-485 1,-882 -287,-10 -211,53 -350,-124 -62,-79 -44,-64 -172,-64 -74,0 -148,0 -221,0 -21,87 -5,501 -5,620 0,211 -1,422 0,634l354 -5z"/>
        <path class="fil1"
              d="M1243 2470l-354 5c-1,-212 0,-423 0,-634 0,-119 -16,-533 5,-620 -18,13 -19,-28 -14,72 14,317 -23,936 2,1183 53,18 263,7 334,7 40,-4 16,-2 27,-13z"/>
        <path class="fil1"
              d="M2538 2567l4 -213 583 0 0 213 -587 0zm0 0c26,13 45,8 77,8 107,-1 468,10 519,-7l-3 -223 -594 4c-11,50 -12,177 1,218z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'MixingValve',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 64.1711
}

.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1;
  fill-rule: nonzero
}
</style>
